export default {

    /**
     * Get a workspace based on name.
     * @param name Name of the workspace
     */
    getWorkspace: function(name) {
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/workspace",
            contentType: "application/json",
            method: "GET",
            data: {
                name: name
            }
        });
    },

    /**
     * Save a workspace.
     * @param name Name of workspace.
     * @param workspace Workspace structure
     */
    saveWorkspace: function(name, workspace) {
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/workspace",
            contentType: "application/json",
            method: "POST",
            data: JSON.stringify({
                name: name,
                workspace: workspace
            })
        });
    },

    /**
     * Reset a set of workspaces.  Can reset any number of workspaces
     * @param name1 First workspace to reset
     * @param name2 Second workspace to reset
     * @param name3 Third workspace to reset
     */
    resetWorkspaces: function(name1, name2, name3) {
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/workspace/",
            contentType: "application/json",
            method: "DELETE",
            data: JSON.stringify([].slice.call(arguments))
        });
    },

    /**
     * Get the current column configuration for the specified grid.
     * @param gridId grid ID
     * @return {*} array of grid settings
     */
    getGridColumns: function(gridId) {
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/grid",
            method: "GET",
            data: {
                gridName: gridId
            }
        });
    },

    /**
     * Save the column sizes/orders for a grid.
     * @param gridId grid ID
     * @param settings grid settings
     * @return {*}
     */
    saveGridColumns: function(gridId, settings) {
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/grid/columns",
            method: "POST",
            contentType: "application/json",
            data: kendo.stringify({
                gridName: gridId,
                gridSettings: settings
            })
        });
    },

    /**
     * Remove the current column configuration for the specified grid for all users.
     * @param gridId grid ID
     */
    deleteGridColumns: function(gridId){
        return $.ajax({
            url: context.path + "/webservices/rest/windowsettings/grid/delete",
            method: "DELETE",
            contentType: "application/json",
            data: kendo.stringify({
                gridName: gridId
            })
        });
    }
}
